import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(() => ({
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
    padding: '20px',
    backgroundColor: '#f5f5f5',
  },
  content: {
    maxWidth: '600px',
    width: '100%',
    backgroundColor: '#ffffff',
    borderRadius: '12px',
    padding: '40px',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
    '@media (max-width: 768px)': {
      padding: '20px',
    },
  },
  title: {
    fontSize: '32px',
    fontWeight: 700,
    color: '#333',
    marginBottom: '12px',
    textAlign: 'center',
    '@media (max-width: 768px)': {
      fontSize: '24px',
    },
  },
  subtitle: {
    fontSize: '16px',
    color: '#666',
    marginBottom: '32px',
    textAlign: 'center',
    lineHeight: '1.5',
  },
  imagePreviewContainer: {
    position: 'relative',
    width: '100%',
    marginBottom: '24px',
    borderRadius: '8px',
    overflow: 'hidden',
    border: '2px solid #e0e0e0',
  },
  imagePreview: {
    width: '100%',
    height: 'auto',
    maxHeight: '400px',
    objectFit: 'contain',
    display: 'block',
    backgroundColor: '#f9f9f9',
  },
  clearButton: {
    position: 'absolute',
    top: '12px',
    right: '12px',
    width: '32px',
    height: '32px',
    borderRadius: '50%',
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    color: '#ffffff',
    border: 'none',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '18px',
    fontWeight: 'bold',
    transition: 'background-color 0.2s',
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.8)',
    },
  },
  buttonsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    marginBottom: '24px',
    '@media (min-width: 768px)': {
      flexDirection: 'row',
      justifyContent: 'space-between',
    },
  },
  actionButton: {
    flex: 1,
    minHeight: '48px',
    fontSize: '16px',
    fontWeight: 600,
    textTransform: 'none',
    borderRadius: '8px',
  },
  submitContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '24px',
  },
  submitButton: {
    minWidth: '200px !important',
    minHeight: '48px',
    fontSize: '16px',
    fontWeight: 600,
    textTransform: 'none',
    borderRadius: '8px',
  },
  deviceInfo: {
    marginTop: '32px',
    padding: '16px',
    backgroundColor: '#f9f9f9',
    borderRadius: '8px',
    border: '1px solid #e0e0e0',
  },
  deviceInfoText: {
    fontSize: '14px',
    color: '#555',
    marginBottom: '8px',
    wordBreak: 'break-word',
    lineHeight: '1.6',
    '&:last-child': {
      marginBottom: 0,
    },
    '& strong': {
      color: '#333',
      fontWeight: 600,
    },
  },
}));
